import { Component, OnInit } from '@angular/core';
import { PredictedSignalService } from '../shared/predicted-signal.service';
import {AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import {PredictedSignal} from '../predicted-signal.model';
import {ApiService} from '../api.service';
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  headElements = ['Mean of the Integrated Profile', 'Standard Deviation of the Integrated Profile',
    'Excess Kurtosis of the Integrated Profile', 'Skewness of the Integrated Profile', 'Mean of the DM-SNR Curve',
    'Standard Deviation of the DM-SNR Curve', 'Excess Kurtosis of the DM-SNR Curve', 'Skewness of the DM-SNR Curve',
    'Prediction', 'Verification', 'True Class', 'Reference Number'];

  constructor(private db: AngularFireDatabase, private apiService: ApiService) {
  }
  itemsRef: AngularFireList<any>;
  items: Observable<PredictedSignal[]>;
  ngOnInit(): void {
    this.itemsRef = this.db.list('asips-3efdd-default-rtdb/Predictions');
    // Use snapshotChanges().map() to store the key
    this.items = this.itemsRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    );
    this.items.subscribe(result => {
      console.log(result.length);
      if (result.length === 0){
        this.confirm_accuracy();
      }
    });

  }
  addItem(newName: string) {
    this.itemsRef.push({ text: newName });
  }
  updateItem(key: string, newText: string) {
    this.itemsRef.update(key, { text: newText });
  }
  verifyItemCorrect(key: string) {
    this.apiService.learn(key)
      .subscribe(data => {
          console.log(data.message);
          // this.logText[this.logText.length] = data.message;
        },
        error => {
          // this.logText[this.logText.length]  = error.message;
          console.error('There was an error!', error);
        });

  }

  verifyItemWrong(key: string) {
    this.apiService.learn(key)
      .subscribe(data => {
          console.log(data.message);
          // this.logText[this.logText.length] = data.message;
        },
        error => {
          // this.logText[this.logText.length]  = error.message;
          console.error('There was an error!', error);
        });

  }
  verifyAll() {
    this.apiService.learnFromAll()
      .subscribe(data => {
          console.log(data.message);
          // this.logText[this.logText.length] = data.message;
        },
        error => {
          // this.logText[this.logText.length]  = error.message;
          console.error('There was an error!', error);
        });
  }
  private confirm_accuracy() {
    const measuresRef = this.db.list('asips-3efdd-default-rtdb');
    measuresRef.update('CurrentEvaluationMeasures', { confirmationState: 1 });
    measuresRef.update('CurrentMeanEvaluationMeasures', { confirmationState: 1 });
  }
}
